module.exports = __webpack_public_path__ + "Flag-200.1f7fc4f8cb60912c029509e2d110fc33.svg";